// 回款计划（销售合同下的业务单据页面配置）
// 【P17】列表纳入 销售合同 + 其会议室订单 名下的回款计划；每行挂 rel_type_name/rel_name（关联对象展示，
//       type=label 仅在列表卡片与详情展示，不出现在新增/编辑表单中）。
import {
  getContractCollectionListData,
  saveContractCollectionData,
  saveContractCollectionEditData,
  saveContractCollectionDeleteData
} from "../../api/api.js";

export default {
  key: "collection",
  title: "回款计划",
  short: "回款计划",
  icon: "clock-o",
  listFn: getContractCollectionListData,
  saveFn: saveContractCollectionData,
  editFn: saveContractCollectionEditData,
  deleteFn: saveContractCollectionDeleteData,
  /* 【P226 优化】回款计划**不再单独新增**。
     原因：回款计划是「挂在会议室订单/销售合同下的收款节奏」，脱离单据单独建没有业务意义，
     且状态字段(未回款/部分回款/已回款)本就是后端按实际回款算出来的，不该手工录。
     实际录入入口在**会议室订单表单内的「回款计划」区**（contractDetail.vue 的 addPayPlan）。
     readonly: true ⇒ 隐藏右上角「新增」按钮，列表与详情仍可正常查看。 */
  readonly: true,
  // 卡片标题：计划日期 · 计划金额（旧逻辑取到 status_name，44 条全显示「部分回款/未回款」无法区分）
  titleFields: ["plan_date", "plan_amount"],
  fields: [
    { prop: "plan_amount", label: "计划金额", type: "number", required: true, group: "回款计划" },
    { prop: "plan_date", label: "计划日期", type: "date", group: "回款计划" },
    {
      prop: "status_name", label: "状态", type: "select", group: "回款计划",
      options: [
        { label: "未回款", value: "未回款" },
        { label: "部分回款", value: "部分回款" },
        { label: "已回款", value: "已回款" }
      ]
    },
    { prop: "rel_type_name", label: "关联类型", type: "label", group: "关联对象" },
    { prop: "rel_name", label: "关联对象", type: "label", group: "关联对象" }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/contract/Collections.js